import styled from "styled-components";
import { media } from "../../../../constants/styles";
import Responsable from "../../../Responsable";
import ButtonV2 from "../../../Button/ButtonV2";

const FloatingButtons = () => {
  const handleClickButton = () => {
    const element = document.getElementById("pluug-section");
    element?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <Container>
      <FloatingWrapper>
        <Responsable
          pc={<ButtonV2 label="견적 문의하기" onClick={handleClickButton} />}
          tablet={
            <ButtonV2 label="견적 문의하기" onClick={handleClickButton} />
          }
          mobile={
            <ButtonV2
              size="S"
              label="견적 문의하기"
              onClick={handleClickButton}
            />
          }
        />
      </FloatingWrapper>
    </Container>
  );
};

export default FloatingButtons;

const Container = styled.div`
  width: 100%;
  position: absolute;
  height: var(--button-absolute-position);
  top: 0px;
  pointer-events: none;
`;

const FloatingWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: end;
  position: sticky;
  width: 100%;
  height: 100px;
  top: calc(100vh - 152px);
  pointer-events: auto;

  ${media.TABLET} {
    top: calc(var(--vh, 1vh) * 100 - 132px);
  }
`;
